import { hardwareCheckIsOffline, needsAudio, needsWebcam } from '../../../../services/HardwareRequirements';
import liveSessioner from '../../../../services/livesession/LiveSessioner';

const confirmHardwareSettingsSelector = {
    selectIsConfirmHardwareSettingsDisabled(livestream, showWarningMissingAudioDevice, showWarningMissingWebcamDevice) {
        const hasMissingDevice = showWarningMissingAudioDevice || showWarningMissingWebcamDevice;
        return livestream.hasConfirmedHardwareSettings || hasMissingDevice;
    },

    selectShowWarningMissingAudioDevice(audioDeviceId, isRemoteProctoringAudioEnabled) {
        return !audioDeviceId && isRemoteProctoringAudioEnabled;
    },

    selectShowWarningMissingWebcamDevice(webcamDeviceId, isRemoteProctoringWebCamEnabled) {
        return !webcamDeviceId && isRemoteProctoringWebCamEnabled;
    },

    selectShowSelectDevice(deviceList) {
        return !!deviceList && deviceList.length >= 1;
    },

    mapStateToProps(state) {
        const { livestream } = state;
        const {
            audioDeviceId,
            audioDevices,
            speakerDeviceId,
            speakerDevices,
            videoDevices,
            webcamDeviceId,
        } = livestream;

        const showWarningMissingWebcamDevice = this.selectShowWarningMissingWebcamDevice(webcamDeviceId, needsWebcam());
        const showWarningMissingAudioDevice = this.selectShowWarningMissingAudioDevice(audioDeviceId, needsAudio());

        return {
            audioDeviceId,
            audioDevices,
            hardwareCheckIsOffline: hardwareCheckIsOffline(),
            isConfirmHardwareSettingsButtonDisabled: this.selectIsConfirmHardwareSettingsDisabled(
                livestream, showWarningMissingAudioDevice, showWarningMissingWebcamDevice),
            showSelectAudioDevice: this.selectShowSelectDevice(audioDevices),
            showSelectSpeakerDevice: this.selectShowSelectDevice(speakerDevices),
            showSelectWebcamDevice: this.selectShowSelectDevice(videoDevices),
            showWarningMissingAudioDevice,
            showWarningMissingWebcamDevice,
            speakerDeviceId,
            speakerDevices,
            videoDevices,
            webcamDeviceId,
            webcamStream: liveSessioner.getGrantedStream(),
        };
    },
};

export default confirmHardwareSettingsSelector;
